import { useTranslation } from 'react-i18next';

import { ModeSelector, RackState } from 'libs/ui';
import { useVideoUrls, useRackState } from 'libs/hooks';
import withRackLogic from '../withRackLogic';
import { AppVideos } from './app-videos/app-videos';
import { AppActions } from './app-actions/app-actions';
import { CashTable } from './tables/cash-table';
import { ChangeTable } from './tables/change-table';
import { ControllWrapper } from '../styledComponents';
import { TopContentWrapper, BottomContent, Info, InfoHeader, StyledControlPanel } from './app.styled';

const AppControl = (props) => {
  const { id, sendControlMsg, status } = props;
  const { t } = useTranslation();
  const mode = status?.mode;
  useRackState({ mode, sendControlMsg, id });
  const { cams } = useVideoUrls({ sendControlMsg, streams: status?.streams, mode, id });

  const offline = mode === 'offline';
  let cl = ''; //offline ? "offline" : "";
  let cl1 = offline ? 'offline' : '';
  let cl2 = offline ? 'offline1' : '';
  if (!mode) {
    cl += ' loading';
    cl1 += ' loading';
    cl2 += ' offline1';
  }

  return (
    <ControllWrapper className={cl} $status={t('clarifications.отключен')}>
      <TopContentWrapper>
        <AppVideos cams={cams} id={id} cl={cl2} />

        <StyledControlPanel className={cl1}>
          <AppActions id={id} sendControlMsg={sendControlMsg} />

          <ModeSelector type="app" id={id} sendControlMsg={sendControlMsg} />
        </StyledControlPanel>
      </TopContentWrapper>

      {status.cashbox && (
        <BottomContent>
          <Info>
            <InfoHeader>{t('windows.Сумма в стекере')}</InfoHeader>
            {!isNaN(Math.round(status.cashbox_sum / 100)) && (
              <InfoHeader className="right">
                {Math.round(status.cashbox_sum / 100)} {t('tables.₽')}
              </InfoHeader>
            )}
            <CashTable items={status.cashbox} />
          </Info>
          <Info>
            <InfoHeader>{t('messages.Выдача сдачи')}</InfoHeader>
            {!isNaN(Math.round(status.payout_sum / 100)) && (
              <InfoHeader className="right">
                {Math.round(status.payout_sum / 100)} {t('tables.₽')}
              </InfoHeader>
            )}
            <ChangeTable items={status.payout} />
          </Info>
        </BottomContent>
      )}
      <RackState id={id} timeOut={10000} offline={offline} />
    </ControllWrapper>
  );
};

export default withRackLogic(AppControl, {
  type: 'app',
  reloadType: 'reboot',
});
